import script from "./BlogReactions.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogReactions.vue?vue&type=script&setup=true&lang=js"

import "./BlogReactions.vue?vue&type=style&index=0&id=09409ab8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09409ab8"]])

export default __exports__